import React, { useState } from 'react';
import styled from 'styled-components';
import Title from './Title';
import { motion } from 'framer-motion';
import { useScroll } from './useScroll';
import { contactAnimation } from 'animation';
import emailjs from 'emailjs-com';
import DOMPurify from 'dompurify';
// import ReCAPTCHA from "react-google-recaptcha";


function Contact() {
  const [element, controls] = useScroll();
  const [formError, setFormError] = useState(null);
  // const [recaptchaValue, setRecaptchaValue] = useState(null);
  // added text and images

  const sendEmail = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
  
    const sanitizedName = DOMPurify.sanitize(formData.get('name').trim());
    const sanitizedEmail = DOMPurify.sanitize(formData.get('email').trim());
    const sanitizedContactNumber = DOMPurify.sanitize(formData.get('contact_number').trim());
    const sanitizedDate = DOMPurify.sanitize(formData.get('date'));
    const sanitizedTime = DOMPurify.sanitize(formData.get('time'));
    const sanitizedMessage = DOMPurify.sanitize(formData.get('message').trim());

    // Data validation
    if (!isValidName(sanitizedName)) {
      setFormError('Please enter a valid name (at least 2 characters).');
      return;
    }

    if (!isValidEmail(sanitizedEmail)) {
      setFormError('Please enter a valid email address.');
      return;
    }

    if (!isValidContactNumber(sanitizedContactNumber)) {
      setFormError('Please enter a valid contact number.');
      return;
    }

    if (!isValidDate(sanitizedDate)) {
      setFormError('Please enter a valid date.');
      return;
    }

    if (!isValidTime(sanitizedTime)) {
      setFormError('Please enter a valid time.');
      return;
    }

    if (!isValidMessage(sanitizedMessage)) {
      setFormError('Please enter a message (at least 10 characters).');
      return;
    }

    // If all checks pass, clear formError
    setFormError(null);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          name: sanitizedName,
          email: sanitizedEmail,
          contact_number: sanitizedContactNumber,
          date: sanitizedDate,
          time: sanitizedTime,
          message: sanitizedMessage,
        },
        process.env.REACT_APP_EMAILJS_USER_ID
      );

      console.log('Email sent successfully');
      alert('Your inquiry has been sent successfully! Please check your email for further details.');
    } catch (error) {
      console.error('Error sending email', error);
    }
  };

  // Validation functions
  const isValidName = (name) => name.length >= 2;
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidContactNumber = (contactNumber) => /^\d{5,15}$/.test(contactNumber);
  const isValidDate = (date) => !isNaN(new Date(date).getTime());
  const isValidTime = (time) => /^([01]\d|2[0-3]):[0-5]\d$/.test(time);
  const isValidMessage = (message) => message.length >= 10;

  return (
    <Section id="contact" ref={element}>
      <Title value="contact" />
      <motion.div
        className="contact"
        variants={contactAnimation}
        animate={controls}
        transition={{
          delay: 0.03,
          type: 'tween',
          duration: 0.8,
        }}
      >
        <div className="contact__title">
          <p>Contact US </p>
          <h2>Quick Contact</h2>
        </div>
        <div className="contact__data">
          <div className="contact__data__description">
            <h4>Kia Ora</h4>
            <p>
              If you have any questions simply use the following contact details. We will get back to you as soon as possible
            </p>
            <div>
              <p>
                <strong>Address:</strong> 114 Ti Rakau Drive Pakuranga, Auckland New Zealand
              </p>
              <p>
                <strong>Email:</strong> susanbrana@gmail.com
              </p>
              {/* <p>
                <strong>Website:</strong> Coming Soon
              </p> */}
            </div>
          </div>
          <div className="contact__data__form">
            <form onSubmit={sendEmail} autoComplete="off">
              <label>
                Name:
                <input type="text" name="name" placeholder="Name" required autoCapitalize="none" />
              </label>
              <label>
                Email:
                <input type="email" name="email" placeholder="Email" required autoCapitalize="none" />
              </label>
              <label>
                Contact Number:
                <input type="tel" name="contact_number" placeholder="Contact Number" required autoCapitalize="none" />
              </label>
              <label>
                Date of Booking:
                <input type="date" name="date" placeholder="Date of Booking" required autoCapitalize="none" />
              </label>
              <label>
                Time of Booking:
                <input type="time" name="time" placeholder="Time of Booking" required autoCapitalize="none" />
              </label>
              <label>
                Message:
                <textarea name="message" placeholder="Message" rows="2" style={{ height: '60px' }} required autoCapitalize="none"></textarea>
              </label>
              
              {/* <ReCAPTCHA
    sitekey="6Lfln0kpAAAAAKYnLyS1kGxxLYoQ9HRHMq-zEQEu"
    onChange={(value) => setRecaptchaValue(value)}
  /> */}

  {formError && <p style={{ color: 'red', marginTop: '5px' }}>{formError}</p>}
  <button type="submit" >
    Send Message
  </button>
            </form>
          </div>
        </div>
      </motion.div>
    </Section>
  );
}


const Section = styled.section`
min-height: 100vh;
.contact {
  color: var(--primary-color);
  margin: 0 18rem;
  &__title {
    margin: 6rem 0 2rem 0;
    p {
      text-transform: uppercase;
      color: var(--primary-color);
    }
    h2 {
      font-size: 2rem;
      color: var(--secondary-color);
    }
  }
  &__data {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 4rem;
    &__description {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      h4 {
        font-size: 1.5rem;
      }
      p {
        text-align: justify;
        margin-top: 20px;
      }
      div {
        p {
          strong {
            text-transform: uppercase;
          }
        }
      }
    }
    &__form {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      input,
      textarea {
        text-transform: uppercase;
        border: none;
        border-bottom: 0.1rem solid var(--secondary-color);
        width: 100%;
        color: var(--secondary-color);
        padding-bottom: 0.7rem;
        &:focus {
          outline: none;
        }
        &::placeholder {
          color: var(--secondary-color);
        }
      }
      textarea {
        width: 100%;
        height: 50%;
        resize: none;
      }
      button {
        width: 100%;
        background-color: transparent;
        border: 0.1rem solid var(--secondary-color);
        height: 3rem;
        color: var(--secondary-color);
        text-transform: uppercase;
        cursor: pointer;
        transition: 0.5s ease-in-out;
        &:hover {
          background-color: var(--secondary-color);
          color: #fff;
        }
      }
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  .contact {
    margin: 1rem;
    padding: 0 1rem;
    &__title {
      margin: 0;
      text-align: center;
      p {
        font-size: 0.8rem;
      }
      h2 {
        font-size: 1.3rem;
      }
    }
    &__data {
      grid-template-columns: 1fr;
      margin: 0;
      p {
        text-align: left;
      }
      &__form {
        button {
          height: 6rem;
        }
      }
    }
  }
}
`;

export default Contact